import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BulkCreateQualificationsService {
  private _bulkCreateDrawerVisible = new ReplaySubject<boolean>(1);
  private _bulkCreatedQualifications = new Subject<void>();
  private _bulkDeleteQualifications = new Subject<void>();

  public bulkCreateDrawerVisible$ =
    this._bulkCreateDrawerVisible.asObservable();

  public bulkCreatedQualifications$ =
    this._bulkCreatedQualifications.asObservable();

  public bulkDeleteQualifications$ =
    this._bulkDeleteQualifications.asObservable();

  setBulkCreateDrawerVisible(visible: boolean): void {
    this._bulkCreateDrawerVisible.next(visible);
  }

  triggerBulkCreatedQualifications(): void {
    this._bulkCreatedQualifications.next();
  }

  triggerBulkDeleteQualifications(): void {
    this._bulkDeleteQualifications.next();
  }
}
